<template>
  <div class="d-flex flex-column flex-grow-1 h-full">
    <div class="">
      <div class="">
        <div id="pot" class="videoContiainer position-relative" @mouseleave="isControleOpen = false"
          @mouseover="isControleOpen = true">
          <video id="elementVideo" ref="videoPlayer" :poster="thumbnails" class="video-js max-height-460"
            controlsList="nodownload" data-setup="{}" height="50%" preload="metadata" width="50%">
            <track v-for="(subtitle, index) in subtitles" :key="index" :label="subtitle.language.text"
              :src="subtitle.file" :srclang="subtitle.language.value" kind="subtitles" />
            <p class="vjs-no-js">
              To view this video please enable JavaScript, and consider
              upgrading to a web browser that
              <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
            </p>
          </video>
          <div class="waterMarkContainer position-absolute d-flex align-items-center justify-content-center flex-column">
            <div class="waterMarkInner">
              <div class="t-headline7 t-color-whiteSelected t-center mgb-16">
                {{ personalInfo ? personalInfo.userId : "" }}
              </div>
              <div class="t-headline7 t-color-blackHover t-center">
                {{ personalInfo ? personalInfo.userId : "" }}
              </div>
            </div>
          </div>
          <div :class="openScreen ? 'typography--resized' : ''"
            class="videoControls position-absolute w-full pdb-20 z-99">
            <div class="t-center">
              <div v-if="firstTrack &&
                firstTrack.cues[0] &&
                firstTrack.cues[0].startTime &&
                elementVideo.currentTime > firstTrack.cues[0].startTime - 1 &&
                elementVideo.currentTime <=
                firstTrack.cues[firstTrack.cues.length - 1].endTime &&
                setedFirstSubtitle
                " :class="lightModeActive
    ? 'on t-color-whiteHighLight'
    : 'on t-color-whiteHigh'
    " class="typography--h7 firstSubtitle subtitle inline-flex bg-contentSubTextON pda-8 b-radius4 font-18 mgb--4">
              </div>
            </div>
            <div v-show="isControleOpen || !isPlaying" class="control-inner pdl-20 pdr-20">
              <div v-if="endedLesson && nextLesson" class="d-flex justify-content-end w-full mgb-26 intro-button">
                <button id="hideButton" :class="lightModeActive
                  ? 'bg-whiteHighLight t-color-headlineBlack'
                  : 'bg-secondaryBtn t-color-contentText'
                  " class="mdc-button b-radius4" @click="moveNextLesson(nextLesson)"
                  @keypress="moveNextLesson(nextLesson)">
                  <span class="mdc-button__ripple"></span>
                  <i aria-hidden="true" class="material-icons mdc-button__icon">play_arrow</i>
                  <span class="mdc-button__label t-body2 font-r">{{ $t("959") }}{{ ": " + nextLesson.name }}</span>
                  <span class="video-btn-overlay"></span>
                </button>
              </div>
              <div v-else-if="endedLesson && !nextLesson && isConsistExam" class="d-flex justify-content-end w-full mgb-26 intro-button">
                <button :class="lightModeActive
                  ? 'bg-whiteHighLight t-color-headlineBlack'
                  : 'bg-secondaryBtn t-color-contentText'
                  " class="mdc-button b-radius4" @click="moveNextLesson(nextLesson)"
                  @keypress="moveNextLesson(nextLesson)">
                  <span class="mdc-button__ripple"></span>
                  <i aria-hidden="true" class="material-icons mdc-button__icon">play_arrow</i>
                  <span class="mdc-button__label t-body2 font-r">{{
                    $t("3187")
                  }}</span>
                  <span class="video-btn-overlay"></span>
                </button>
              </div>
              <div class="position-relative">
                <div v-show="isControlsVisible" class="range-slider">
                  <input id="seekBar" v-model="setCurrentSlideValue" class="range-slider__range video-status w-full"
                    data-orientation="vertical" max="100" min="0" type="range" @change="onChanged" @input="onSliding"
                    :disabled="!learningPolicy.skipContents" :class="{'cursor-disabled': !learningPolicy.skipContents}" />
                </div>
              </div>

              <div class="controls d-flex justify-conetent-between align-items-center mgt-16">
                <div class="d-flex justify-conetent-between align-items-center flex-grow-1">
                  <div class="material-icons mgr-28 t-headline11 t-color-white cursor-pointer"
                  :class="{'cursor-disabled': !learningPolicy.skipContents}"
                    @click="moveBackward(learningPolicy.skipContents)"
                    @keypress="moveBackward(learningPolicy.skipContents)">
                    replay_10
                  </div>
                  <img v-show="!isPlaying" alt="play" class="mgr-28 w-24 h-24" src="/img/play.svg"
                    @click="onTogglePlayPause()" @keypress="onTogglePlayPause()" />
                  <div v-show="isPlaying" class="material-icons mgr-28 t-headline11 t-color-white cursor-pointer"
                    @click="onTogglePlayPause()" @keypress="onTogglePlayPause()">
                    pause
                  </div>
                  <div class="material-icons mgr-28 t-headline11 t-color-white cursor-pointer"
                    :class="{'cursor-disabled': !learningPolicy.skipContents}"
                    @click="moveForward(learningPolicy.skipContents)"
                    @keypress="moveForward(learningPolicy.skipContents)">
                    forward_10
                  </div>
                  <div class="timeControl desktop">
                    <span :class="lightModeActive
                      ? 't-color-whiteMediumLight'
                      : 't-color-whiteHigh'
                      " class="currentTime t-body7 font-rn mgr-10" v-text="currentTimeParsed"></span>
                    <span :class="lightModeActive
                      ? 't-color-whiteMediumLight'
                      : 't-color-whiteHigh'
                      " class="t-body7 font-rn">/</span>
                    <span :class="lightModeActive
                      ? 't-color-whiteMediumLight'
                      : 't-color-whiteHigh'
                      " class="totalTime t-body7 font-rn mgl-10" v-text="fullLength"></span>
                  </div>
                </div>

                <div class="d-flex justify-conetent-between align-items-center">
                  <div class="position-relative">
                    <img id="soundId" alt="sound" class="mgr-28 w-24 h-24" src="/img/sound.svg" @click="setSoundHandler"
                      @keypress="setSoundHandler" />
                    <div v-if="isSound" :data-id="currentSound"
                      class="range-slider volume-setting d-flex justify-conetent-center align-items-center pdl-16 pdr-16">
                      <div class="volume-slider-wrapper">
                        <input v-model="currentSound"
                          :style="`background:linear-gradient(90deg, var(--Saleline) ${currentSound}%, var(--WhiteBorder) ${currentSound}%)`"
                          class="custom-input range-slider__range" max="100" min="0" orient="vertical" type="range"
                          @change="soundHandler" @input="soundHandler" />
                      </div>
                    </div>
                  </div>
                  <div id="playSpeed" class="position-relative">
                    <img alt="play speed conrol" class="mgr-28 w-24 h-24" src="/img/play-speed.svg"
                      @click="setPlaybackHandler" @keypress="setPlaybackHandler" />
                    <div class="position-absolute speed-control">
                      <div v-if="isPlayback" class=" ">
                        <ul aria-hidden="true" aria-orientation="vertical" class="mdc-list pdt-8 pdb-8" role="menu"
                          tabindex="-1">
                          <li class="mdc-list-item d-flex pdt-12 pdb-12 pdl-50" role="menuitem" @click="playBackItem"
                            @keypress="playBackItem">
                            <span class="mdc-list-item__ripple"></span>
                            <span
                              class="mdc-list-item__text t-body2 font-r t-color-whiteHigh d-flex align-items-center playBackItem pdl-12"
                              speed-data="0.5">
                              <i :class="{
                                'd-none':
                                  elementVideo &&
                                  elementVideo.playbackRate != '0.5',
                              }" class="material-icons mgr-16">check</i>0.5</span>
                          </li>
                          <li class="mdc-list-item d-flex pdt-12 pdb-12 pdl-50" role="menuitem" @click="playBackItem"
                            @keypress="playBackItem">
                            <span class="mdc-list-item__ripple"></span>
                            <span
                              class="mdc-list-item__text t-body2 font-r t-color-whiteHigh d-flex align-items-center playBackItem pdl-12"
                              speed-data="0.7"><i :class="{
                                'd-none':
                                  elementVideo &&
                                  elementVideo.playbackRate != '0.7',
                              }" class="material-icons mgr-16">check</i>0.7</span>
                          </li>
                          <li class="mdc-list-item d-flex pdt-12 pdb-12 pdl-50" role="menuitem" @click="playBackItem"
                            @keypress="playBackItem">
                            <span class="mdc-list-item__ripple"></span>
                            <span
                              class="mdc-list-item__text t-body2 font-r t-color-whiteHigh d-flex align-items-center playBackItem pdl-12"
                              speed-data="1">
                              <i :class="{
                                'd-none':
                                  elementVideo &&
                                  elementVideo.playbackRate != '1',
                              }" class="material-icons mgr-16">check</i>
                              1
                            </span>
                          </li>
                          <li class="mdc-list-item d-flex pdt-12 pdb-12 pdl-50" role="menuitem" @click="playBackItem"
                            @keypress="playBackItem">
                            <span class="mdc-list-item__ripple"></span>
                            <span
                              class="mdc-list-item__text t-body2 font-r t-color-whiteHigh d-flex align-items-center playBackItem pdl-12"
                              speed-data="1.25"><i :class="{
                                'd-none':
                                  elementVideo &&
                                  elementVideo.playbackRate != '1.25',
                              }" class="material-icons mgr-16">check</i>1.25</span>
                          </li>
                          <li class="mdc-list-item d-flex pdt-12 pdb-12 pdl-50" role="menuitem" @click="playBackItem"
                            @keypress="playBackItem">
                            <span class="mdc-list-item__ripple"></span>
                            <span
                              class="mdc-list-item__text t-body2 font-r t-color-whiteHigh d-flex align-items-center playBackItem pdl-12"
                              speed-data="1.5"><i :class="{
                                'd-none':
                                  elementVideo &&
                                  elementVideo.playbackRate != '1.5',
                              }" class="material-icons mgr-16">check</i>1.5</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="position-relative">
                    <img id="subTitileIcon" alt="subtitle control" class="mgr-28 w-24 h-24" src="/img/subtitle.svg"
                      @click="setSubtitleHandler" @keypress="setSubtitleHandler" />
                    <div class="position-absolute subtitle-setting">
                      <div v-if="isSubtitlesVisible" class=" ">
                        <ul aria-hidden="true" aria-orientation="vertical" class="mdc-list pdt-8 pdb-8" role="menu"
                          tabindex="-1">
                          <li class="mdc-list-item d-flex pdl-50 h-48" role="menuitem" @click="setFirstSubtitle('')"
                            @keypress="setFirstSubtitle('')">
                            <span class="mdc-list-item__ripple"></span>
                            <span
                              class="mdc-list-item__text t-body2 font-r t-color-whiteHigh w-full d-flex align-items-center playBackItem pdl-12">
                              <i v-show="setedFirstSubtitle === ''" class="material-icons mgr-16">check</i>
                              {{ $t("1110") }}</span>
                          </li>
                          <li v-for="(subtitle, index) in subtitles" :key="index" class="mdc-list-item d-flex pdl-50 h-48"
                            role="menuitem" @click="setFirstSubtitle(subtitle.language.value)" @keypress="
                              setFirstSubtitle(subtitle.language.value)
                              ">
                            <span class="mdc-list-item__ripple"></span>
                            <span
                              class="mdc-list-item__text t-body2 font-r t-color-whiteHigh d-flex w-full align-items-center playBackItem pdl-12">
                              <i v-show="setedFirstSubtitle === subtitle.language.value
                                " class="material-icons mgr-16">check</i>
                              {{ subtitle.language.text }}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <img id="hideShowFullScreen" alt="full screen" class="w-24 h-24" src="/img/arrow-extend.svg"
                    @click="openFullscreen(), toggleFullscreen()" @keypress="openFullscreen(), toggleFullscreen()" />
                  <div id="hideShowPAndP"
                    class="position-relative mdc-menu-anchor menu-container cursor-pointer header-toggle d-none">
                    <i :class="lightModeActive ? 't-color-white' : 't-color-whiteHigh'
                      " class="material-icons mdc-icon-button t-headline6 js--dropdown-toggle"
                      @click.prevent="toggleAddedMenu" @keypress.prevent="toggleAddedMenu">more_vert</i>
                    <div id="addedMenu" class="mdc-menu mdc-menu-surface toggle-menu">
                      <ul aria-hidden="true" aria-orientation="vertical" class="mdc-list" role="menu" tabindex="-1">
                        <li id="pictureInPicture" class="mdc-list-item" role="menuitem" @click="pictureInPicture"
                          @keypress="pictureInPicture">
                          <i class="material-icons mdc-icon-button t-headline6">picture_in_picture</i>
                          <span class="mdc-list-item__ripple"></span>
                          <span class="mdc-list-item__text t-body6 font-r">{{
                            $t("3330")
                          }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 퀴즈 팝업 -->
          <timeline-quiz-pop v-if="isTimelineQuiz" :currentTimelineContents="currentTimelineContents"
            @closeQuizPop="closeQuizPop()" @openQuizDetail="openQuizDetail()" />

          <timeline-quiz-detail v-if="isQuizVisible" :currentTimelineContents="currentTimelineContents"
            :lightModeActive="lightModeActive" @closeQuizDetail="closeQuizDetail()" />

          <!-- 리소스 팝업 -->
          <timeline-resource-pop v-if="isTimelineResource" :currentTimelineContents="currentTimelineContents"
            @closeResource="closeResource()" @openResource="openResource()" />
        </div>
      </div>
      <div class="divider-white divider-subtabs"></div>
      <div class="d-flex align-items-center justify-contents-between w-full">
        <div class="t-body1 t-color-whiteHigh mgt-21 mgb-21 pdl-20 pdr-30 flex-grow-1">
          {{ $t("3721") }}
        </div>
        <div id="selectDuty" class="mdc-select mdc-select--outlined mdc--select__custom--darkmode mgr-20">
          <span class="mdc-select__dropdown-icon">
            <svg class="mdc-select__dropdown-icon-graphic" focusable="false" viewBox="7 10 10 5">
              <polygon class="mdc-select__dropdown-icon-inactive" fill-rule="evenodd" points="7 10 12 15 17 10"
                stroke="none"></polygon>
              <polygon class="mdc-select__dropdown-icon-active" fill-rule="evenodd" points="7 15 12 10 17 15"
                stroke="none"></polygon>
            </svg>
          </span>
          <select v-if="subtitles.length > 0" v-model="setedFirstSubtitle"
            :class="setedFirstSubtitle ? 'hasActiveVal' : ''"
            class="font-r mdc-select__native-control t-color-whiteHigh mdc-select__anchor h-48 mdc-select-control-custom t-body6 pdt-12 seleduty select-no-appearance"
            @change="onChangeLang($event)">
            <option :selected="setedFirstSubtitle === ''" value="">
              {{ $t("1110") }}
            </option>
            <option v-for="(subtitle, index) in subtitles" :key="index"
              :selected="setedFirstSubtitle === subtitle.language.value" :value="subtitle.language.value">
              {{ subtitle.language.text }}
            </option>
          </select>
          <select v-else
            class="font-r mdc-select__native-control t-color-whiteHigh mdc-select__anchor h-48 mdc-select-control-custom t-body6 pdt-12 select-no-appearance">
            <option value="None">
              {{ $t("1110") }}
            </option>
          </select>
          <div class="mdc-notched-outline">
            <div class="mdc-notched-outline__leading"></div>
            <div class="mdc-notched-outline__notch"></div>
            <div class="mdc-notched-outline__trailing"></div>
          </div>
        </div>
      </div>
      <div class="divider-white divider-subtabs"></div>
    </div>
    <!-- <div class="mgt-32 pdl-30">
    </div> -->

    <div v-if="subtitles.length > 0" class="subtitle-display pdl-30 pdr-30 flex-grow-1 scroll-y scrollable-content">
      <videotype-subtitle v-if="setedFirstSubtitle.length > 0" :elementVideo="elementVideo" :firstTrack="firstTrack"
        :firstTrackStartTime="firstTrackStartTime" :lessonName="lessonName" :secondTrack="secondTrackCues"
        :setedFirstSubtitle="setedFirstSubtitle" />
    </div>
    <div v-else class="subtitle-display t-body1 t-color-whiteHigh t-center pdt-37 flex-grow-1 scroll-y">
      {{ $t("3321") }}
    </div>
  </div>
</template>
<script>
/**
 * 나의 학습 차시 학습창 - 비디오 컨텐츠 컴포넌트(my learning lesson study - video content component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from "@/api/learnApi.js";
import { videoTypeMixins } from "@/mixins/videoType";
import { MDCRipple } from "@material/ripple";
import { MDCSelect } from "@material/select";

export default {
  props: ["nextLesson", "lightModeActive", "fetchLectureList"],

  data() {
    return {
      lessonData: null,
      lessonName: "",
      lessonsList: [],
      nextLessonName: "",
      currentProgressionId: "",
      rate: 0,
      last: 0,
      recent: 0,
      showLectureList: false,

      // 자막 관련 데이터(subtitles data)
      subtitles: [],
      setedFirstSubtitle: "",
      setedSecondSubtitle: null,
      firstTrack: null,
      secondTrack: null,
      firstTrackStartTime: 0,
      secondTrackStartTime: 0,
      firstTrackCues: null,
      secondTrackCues: null,
      endedLesson: false,
      personalInfo: null,
      type: "video",
      thumbnails: null,
      questionChat: null,
      video: null,
      togglePipButton: null,
      addedMenu: null,
      slidingVideoArr: [],

      //타임라인 관련 데이터(timeline data)
      isTimelineQuiz: false,
      isTimelineResource: false,
      timelineContents: [],
      currentTimelineContents: null,

      // 북마크 좋아요 관련 데이터
      isLiked: false,
      isBookmarked: false,
      likes: false,
      likesCount: 0,
      clipping: false,
      clippingCount: 0,
      timerId: null,
      openScreen: false,
      learningPolicy: false,
      isConsistExam: true,
    };
  },

  mixins: [videoTypeMixins],

  components: {
    "videotype-subtitle": () => import("@/components/study/VideoTypeSubtitle"),
    "timeline-quiz-detail": () =>
      import("@/components/study/TimelineQuizDetail.vue"),
    "timeline-quiz-pop": () => import("@/components/study/TimelineQuizPop.vue"),
    "timeline-resource-pop": () =>
      import("@/components/study/TimelineResourcePop.vue"),
  },

  computed: {
    setCurrentSlideValue() {
      this.setMaterialUi();
      this.setSubtitles(this.$data);
      return this.currentSlideValue;
    },
  },

  mounted() {
    this.toggleMenu();
    this.videoPlayMount();
    this.fetchMemberInfo();
    this.fetchLearnLessonContents();
    this.setMaterialUi();
    const select = new MDCSelect(document.querySelector("#selectDuty"));
    this.fetchBasicInfo();
		this.getExamInfo();
  },

  beforeDestroy() {
    document.removeEventListener("mousemove", this.eventHandler);
    document.removeEventListener("keydown", this.eventHandler);
    this.exitPiPMode();
  },

  methods: {
    eventHandler() {
      const hideButton = document.querySelector("#hideButton");
      if (hideButton) {
        hideButton.style.display = "none";
      }
      clearTimeout(this.timerId);
    },

    fetchLecture() {
      this.fetchLectureList();
    },

    videoPlayMount() {
      let params = this.setParams();

      $(document).bind(
        "webkitfullscreenchange mozfullscreenchange fullscreenchange",
        () => {
          var state =
            document.fullScreen ||
            document.mozFullScreen ||
            document.webkitIsFullScreen;
          var event = state ? "FullscreenOn" : "FullscreenOff";
          // Now do something interesting
          if (event === "FullscreenOff") {
            this.openScreen = false;
            document.querySelector(".video-js").classList.add("max-height-460");
            document.getElementById("hideShowPAndP").classList.add("d-none");
            document
              .getElementById("hideShowFullScreen")
              .classList.remove("d-none");
            document.getElementById("subTitileIcon").classList.add("mgr-28");
            document.getElementById("subTitileIcon").classList.remove("d-none");
            document.getElementById("playSpeed").classList.remove("d-none");
            document.getElementById("soundId").classList.add("mgr-28");
          } else {
            this.openScreen = true;
            document
              .querySelector(".video-js")
              .classList.remove("max-height-460");
            document.getElementById("hideShowPAndP").classList.remove("d-none");
            document
              .getElementById("hideShowFullScreen")
              .classList.add("d-none");
            document.getElementById("subTitileIcon").classList.remove("mgr-28");
            document.getElementById("subTitileIcon").classList.add("d-none");
            document.getElementById("playSpeed").classList.add("d-none");
            document.getElementById("soundId").classList.remove("mgr-28");
          }
        }
      );

      // 동영상 재생시 자막 설정(Subtitle settings during video playback)
      this.elementVideo.onplay = () => {
        this.setSubtitles();
      };

      // 동영상 끝났을 경우 진도 저장(Save progress when video is over)
      this.elementVideo.onended = async () => {
        let myLession = this.nextLesson;
        let myRoute = this.$route;
        let myRouter = this.$router;
        this.endedLesson = true;
        this.updateProgress();
        await this.openNextLearning();
			  this.fetchLecture();
        this.setMaterialUi();
        var self = this;
        this.timerId = setTimeout(function () {
          let learnId = myRoute.params.learnId;
          let status = myRoute.query.status;
          if (
            myLession &&
            myLession.contentsType &&
            myLession.contentsType.value === "VIDEO"
          ) {
            myRouter.push(
              `/learn-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=` +
              status
            );
          } else if (
            myLession &&
            myLession.contentsType &&
            myLession.contentsType.value === "EXAM_PAPER"
          ) {
            myRouter.push(
              `/learn/${learnId}/lessonExam/${myLession.examineeId}/intro?status=` +
              status
            );
          } else if (
            myLession &&
            myLession.contentsType &&
            myLession.contentsType.value === "PDF"
          ) {
            myRouter.push(
              `/learn-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=` +
              status
            );
          } else if (
            myLession &&
            myLession.contentsType &&
            myLession.contentsType.value === "SLIDE"
          ) {
            myRouter.push(
              `/learn-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=` +
              status
            );
          } else if (
            myLession &&
            myLession.contentsType &&
            myLession.contentsType.value === "HTML"
          ) {
            myRouter.push(
              `/learn-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=` +
              status
            );
          } else if (
            myLession &&
            myLession.contentsType &&
            myLession.contentsType.value === "INTERACTIVE_HTML"
          ) {
            myRouter.push(
              `/learn-study/${learnId}/${myLession.id}/lessonContents/${myLession.progressionId}?status=` +
              status
            );
          } else if (
            myLession &&
            myLession.contentsType &&
            myLession.contentsType.value === "LIVE_SESSION"
          ) {
            self.liveLessonPopup(myLession, myRoute, myRouter);
          } else {
            myRouter.push(`/learn/${learnId}?status=` + status);
          }
        }, 5000);

        document.addEventListener("mousemove", this.eventHandler);
        document.addEventListener("keydown", this.eventHandler);
      };

      // 동영상 재생 준비 완료되었을 경우 재생(Play when video is ready to play)
      this.elementVideo.onloadeddata = () => {
        if (this.elementVideo.readyState >= 2) {
          this.elementVideo.play();
        }
      };

      learnApi
        .learnLessonTimelinecontents(params)
        .then((response) => {
          this.timelineContents = response.data.data;
        })
        .catch((err) => { });
    },

    toggleMenu() {
      if (document.querySelectorAll(".toggle-menu")) {
        const menuEls = Array.from(document.querySelectorAll(".toggle-menu"));
        menuEls.forEach((menuEl) => {
          // Initialize MDCSimpleMenu on each ".mdc-simple-menu"
          const menu = new mdc.menu.MDCMenu(menuEl);
          // We wrapped menu and toggle into containers for easier selecting the toggles
          const dropdownToggle = menuEl.parentElement.querySelector(
            ".js--dropdown-toggle"
          );
          dropdownToggle.addEventListener("click", () => {
            menu.open = !menu.open;
          });
        });
      }
    },

    liveLessonPopup(myLession, myRoute, myRouter) {
      let params = {
        learnId: myRoute.params.learnId,
        progressionId: myLession.progressionId,
      };
      learnApi
        .learnLessonContents(params)
        .then((response) => {
          let liveSessionTrueFalse =
            response.data.data.liveSession.canParticipate;
          if (liveSessionTrueFalse === false) {
            this.$alert({
              title: this.$t("3434"), // 학습을 중단한 강의입니다.
              content: this.$t("3435"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
              accept: this.$t("3436"), // 확인
            })
              .then(() => {
                document.getElementById("hideButton").style.display = "none";
              })
              .catch(() => { });
          } else {
            this.zoomMeeting(myLession, response.data.data);
          }
        })
        .catch((err) => { });
    },

    zoomMeeting(
      lesson,
      liveSessionData,
      target = "_blank",
      rel = "noopener noreferrer"
    ) {
      window.open(liveSessionData.liveSession.url, target, rel);
    },

    moveNextLesson(lesson) {
      let learnId = this.$route.params.learnId;
      let status = this.$route.query.status;
      if (
        lesson &&
        lesson.contentsType &&
        lesson.contentsType.value === "VIDEO"
      ) {
        this.$router.push(
          `/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=` +
          status
        );
      } else if (
        lesson &&
        lesson.contentsType &&
        lesson.contentsType.value === "EXAM_PAPER"
      ) {
        this.$router.push(
          `/learn/${learnId}/lessonExam/${lesson.examineeId}/intro?status=` +
          status
        );
      } else if (
        lesson &&
        lesson.contentsType &&
        lesson.contentsType.value === "PDF"
      ) {
        this.$router.push(
          `/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=` +
          status
        );
      } else if (
        lesson &&
        lesson.contentsType &&
        lesson.contentsType.value === "SLIDE"
      ) {
        this.$router.push(
          `/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=` +
          status
        );
      } else if (
        lesson &&
        lesson.contents &&
        lesson.contents.lcms &&
        lesson.contents.lcms.type &&
        lesson.contents.lcms.type.value === "HTML"
      ) {
        this.$router.push(
          `/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=` +
          status
        );
      } else if (
        lesson &&
        lesson.contents &&
        lesson.contents.lcms &&
        lesson.contents.lcms.type &&
        lesson.contents.lcms.type.value === "INTERACTIVE_HTML"
      ) {
        this.$router.push(
          `/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=` +
          status
        );
      } else if (
        lesson &&
        lesson.contentsType &&
        lesson.contentsType.value === "LIVE_SESSION"
      ) {
        let params = {
          learnId: this.$route.params.learnId,
          progressionId: lesson.progressionId,
        };
        learnApi
          .learnLessonContents(params)
          .then((response) => {
            let liveSessionTrueFalse =
              response.data.data.liveSession.canParticipate;
            if (liveSessionTrueFalse === false) {
              this.$alert({
                title: this.$t("3434"), // 학습을 중단한 강의입니다.
                content: this.$t("3435"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
                accept: this.$t("3436"), // 확인
              })
                .then(() => { })
                .catch(() => { });
            } else {
              this.$router.push({
                name: "LessonView",
                params: {
                  learnId: this.$route.params.learnId,
                  lessonId: lesson.id,
                  progressionId: lesson.progressionId,
                },
                query: this.$route.query,
              });
            }
          })
          .catch((err) => { });
      } else {
        this.$router.push(`/learn/${learnId}?status=` + status);
      }
    },

    onChangeLang(event) {
      this.setFirstSubtitle(event.target.value);
    },

    setFirstSubtitle(language) {
      if (this.firstSubtitle === language) {
        // this.firstSubtitle = ''
      } else {
        this.firstSubtitle = language;
      }
      this.setSubtitles(this.$data);
    },

    toggleAddedMenu() {
      this.addedMenu.open = !this.addedMenu.open;
    },

    pictureInPicture() {
      this.video = document.getElementById("elementVideo");
      this.togglePipButton = document.getElementById("pictureInPicture");
      this.togglePipButton.hidden =
        !document.pictureInPictureEnabled || this.video.disablePictureInPicture;
      this.video.requestPictureInPicture();
      this.togglePipButton.addEventListener("click", async () => {
        await this.video.requestPictureInPicture();
      });
    },

    // 진도저장 API 호출(update progress)
    updateProgress() {
      let params = this.setParams();
      let responseData = null;
      learnApi
        .learnLessonProgression(params)
        .then((response) => {
          responseData = response.data.data;
          this.rate = responseData.rate;
          this.last = responseData.last;
        })
        .catch((err) => { });
    },

    // API 파라미터 설정(set parameter)
    setParams() {
      let params = {
        total: this.elementVideo.duration,
        current: this.elementVideo.currentTime,
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId,
      };
      return params;
    },

    // 자막 설정(set subtitles)
    setSubtitles(data) {
      let firstSubtitle = document.getElementsByClassName("firstSubtitle");
      let secondSubtitle = document.getElementsByClassName("secondSubtitle");

      // 기본자막 설정(Default subtitle setting)
      if (!data && this.lessonData.video.subtitles.length) {
        data = {
          firstSubtitle: this.lessonData.video.subtitles[0].language.value,
          secondSubtitle: "",
        };
      }
      if (data) {
        // set first subtitles
        if (data.firstSubtitle) {
          this.setedFirstSubtitle = data.firstSubtitle;
          this.firstTrack =
            this.elementVideo.textTracks[
            _.findIndex(this.elementVideo.textTracks, (track) => {
              return track.language === data.firstSubtitle;
            })
            ];
          this.firstTrack.mode = "hidden";
          this.firstTrackCues = this.firstTrack.cues;

          // 비디오 진도 바뀔때(When the video progress changes)
          this.firstTrack.oncuechange = (e) => {
            let cue = this.firstTrack.activeCues[0];
            if (cue) {
              this.firstTrackStartTime = cue.startTime;
              for (let i = 0; i < firstSubtitle.length; i++) {
                firstSubtitle[i].classList.remove("on");
                firstSubtitle[i].innerHTML = "";
                firstSubtitle[i].classList.add("on");
                firstSubtitle[i].appendChild(cue.getCueAsHTML());
              }
            }
          };
        } else {
          if (this.firstTrack) {
            this.setedFirstSubtitle = "";
            this.firstTrack.oncuechange = () => { };
            this.firstTrack = null;
            this.firstTrackCues = null;
          }

          for (let i = 0; i < firstSubtitle.length; i++) {
            firstSubtitle[i].innerHTML = "";
          }
        }

        // set second subtitles
        if (data.secondSubtitle) {
          this.setedSecondSubtitle = data.secondSubtitle;
          this.secondTrack =
            this.elementVideo.textTracks[
            _.findIndex(this.elementVideo.textTracks, (track) => {
              return track.language === data.secondSubtitle;
            })
            ];

          this.secondTrack.mode = "hidden";
          this.secondTrackCues = this.secondTrack.cues;
          // 비디오 진도 바뀔때(When the video progress changes)
          this.secondTrack.oncuechange = (e) => {
            let cue = this.secondTrack.activeCues[0];
            this.secondTrackStartTime = cue.startTime;
            if (cue) {
              for (let i = 0; i < secondSubtitle.length; i++) {
                secondSubtitle[i].classList.remove("on");
                secondSubtitle[i].innerHTML = "";
                secondSubtitle[i].classList.add("on");
                secondSubtitle[i].appendChild(cue.getCueAsHTML());
              }
            }
          };
        } else {
          if (this.secondTrack) {
            this.setedSecondSubtitle = "";
            this.secondTrack.oncuechange = () => { };
            this.secondTrack = null;
            this.secondTrackCues = null;
          }
          for (let i = 0; i < secondSubtitle.length; i++) {
            secondSubtitle[i].innerHTML = "";
          }
        }
      }
    },

    fetchMemberInfo() {
      learnApi.getMemberInfo().then((response) => {
        this.personalInfo = response.data.data;
      });
    },

    //나의 학습 상세로 이동(Go to my learning details)
    moveLearnView() {
      let goBackBookMarkLessson = localStorage.getItem("videoBookMarkLesson");
      let goBackLikeLessson = localStorage.getItem("videoLikeLesson");
      if (goBackBookMarkLessson === "setVideoBookMarkLesson") {
        localStorage.removeItem("videoBookMarkLesson");
        this.$router.push({
          name: "BookMarkedLesson",
        });
      } else if (goBackLikeLessson === "setVideoLikeLesson") {
        localStorage.removeItem("videoLikeLesson");
        this.$router.push({
          name: "LikedLesson",
        });
      } else {
        this.$router.push({
          name: "LearnView",
          params: { learnId: this.$route.params.learnId },
          query: this.$route.query,
        });
      }
    },

    updateLikesCount(data) {
      this.likes = data.likes;
      if (data.likesCount < 0) {
        this.likesCount = 0;
      } else {
        this.likesCount = data.likesCount;
      }
    },

    updateBookmarkCount(data) {
      this.clipping = data.clipping;
      if (data.clippingCount < 0) {
        this.clippingCount = 0;
      } else {
        this.clippingCount = data.clippingCount;
      }
    },

    //차시 컨텐츠 정보 API 호출(get lesson contents data)
    fetchLearnLessonContents() {
      let params = this.setParams();
      let responseData = null;

      learnApi
        .learnLessonContents(params)
        .then((response) => {
          responseData = response.data.data;
          this.lessonData = responseData;
          this.lessonName = this.lessonData.lessonName;
          this.rate = this.lessonData.rate;
          this.video = this.lessonData.video;
          this.last = this.lessonData.last;
          this.recent = this.lessonData.recent;
          this.totalTime = this.lessonData.video.duration;
          this.subtitles = this.lessonData.video.subtitles;
          this.thumbnails = this.lessonData.video.thumbnails[0];
          this.currentProgressionId = this.lessonData.progressionId;

          this.likes = this.lessonData.likes;
          this.likesCount = this.lessonData.likesCount;
          this.clipping = this.lessonData.clipping;
          this.lessonData.likesCount < 0
            ? (this.likesCount = 0)
            : (this.likesCount = this.lessonData.likesCount);
          this.lessonData.clippingCount < 0
            ? (this.clippingCount = 0)
            : (this.clippingCount = this.lessonData.clippingCount);

          this.elementVideo.src = this.video.file;
          this.learningLanguage = this.lessonData.learningLanguage;

          // 학습중일 경우 처음부터 보기 이어보기 팝업(If you are learning, pop-up view from the beginning)
          if (this.rate > 0 && this.rate < 100) {
            this.$confirm({
              title: this.$t("173"), // '학습 중인 강의입니다.',
              content: this.$t("174") + "<br>" + this.$t("175"), //'이전에 학습했던 이력이 있습니다.<br>이어서 학습하시겠습니까?',
              accept: this.$t("177"), //'이어서 보기',
              cancel: this.$t("176"), //'처음부터 보기',
            })
              .then(() => {
                this.elementVideo.currentTime = this.recent;
                this.elementVideo.play();
              })
              .catch(() => {
                this.elementVideo.currentTime = 0;
                this.elementVideo.play();
              });
          } else {
            this.elementVideo.play();
          }
        })
        .catch((err) => { });
    },

    fetchBasicInfo() {
      let params = this.setParams();
      learnApi
        .learnViewBasic(params)
        .then((response) => {
          this.learningPolicy = response.data.data.learningPolicy;
        })
        .catch((err) => { });
    },

    toggleFullscreen() {
      if (!document.fullscreenElement) {
        document.getElementById("hideShowPAndP").classList.remove("d-none");
        // document.querySelector(".video-js").classList.remove("max-height-460");
      } else if (document.exitFullscreen) {
        document.getElementById("hideShowPAndP").classList.add("d-none");
      }
    },

    // 타임라인 퀴즈 팝업 닫기(Close the timeline quiz popup)
    closeQuizPop() {
      this.isTimelineQuiz = false;
    },

    setMaterialUi() {
      const settings = {
        fill: `var(--Saleline)`,
        background: "rgba(255, 255, 255, 0.38)",
      };

      const sliders = document.querySelectorAll(".range-slider");
      Array.prototype.forEach.call(sliders, (slider) => {
        slider.querySelector("input").addEventListener("input", (event) => {
          applyFill(event.target);
        });
        applyFill(slider.querySelector("input"));
      });

      function applyFill(slider) {
        const percentage =
          (100 * (slider.value - slider.min)) / (slider.max - slider.min);
        const bg = `linear-gradient(90deg, ${settings.fill} ${percentage}%, ${settings.background
          } ${percentage + 0.1}%)`;
        slider.style.background = bg;
      }
    },

		async getExamInfo() {
			const params = this.setParams();
			try {
				const result = await learnApi.learnViewExams(params);
				if (result && result.data.data && result.data.data.length === 0) {
					this.isConsistExam = false;
				}
			} catch (error) {
				console.log("GET EXAM ERROR : ", error);
			}
		},

    async openNextLearning() {
			try {
				await learnApi.openNextLearning(this.$route.params.learnId)
			} catch (error) {
				console.log("Open Next Learning Error : ", error);
			}
		},
  },
};
</script>
<style scoped>
.mdc-select--outlined.mdc--select__custom--darkmode:not(.mdc-select--disabled) .mdc-select__anchor:not(.small) {
  padding: 14px 12px !important;
}

/* width */
::-webkit-scrollbar {
  width: 6px;
}

/* Track */
.scrollable-content::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
.scrollable-content::-webkit-scrollbar-thumb {
  background: #efefef !important;
}

[data-theme="light"] .scrollable-content::-webkit-scrollbar-thumb {
  background: #c8c8c8 !important;
}

/* Handle on hover */
.scrollable-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.scrollable-bottom-right {
  padding: 16px;
  box-sizing: border-box;
  height: 80% !important;
}

.single-slide .custom-nav i {
  text-shadow: 0px 1px 3px var(--Shadow1);
  font-size: 32px;
}

.single-slide .swiper-pagination-bullet {
  background: var(--DocumentWhite);
  opacity: 1;
}

.single-slide .swiper-pagination-bullet-active {
  background: var(--Primary);
  opacity: 1;
}

.play-icon {
  font-size: 62px;
}

.fixed-bottom-icon.bg-mainBtn {
  position: fixed;
  bottom: 25px;
  right: 16px;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 2px 4px 0 var(--Shadow2);
  z-index: 99;
}

.playerBG {
  /*padding-top: unset;*/
}

.video-container {
  min-height: unset;
}

.video-js {
  width: 100%;
  height: 100%;
}

.max-height-460 {
  max-height: 482px !important;
}

.height-recalc {
  height: calc(100% - 130px);
}

#addedMenu {
  top: -64px !important;
  min-width: 220px;
}

.cursor-disabled {
  cursor: not-allowed !important; 
  color: var(--WhiteDisabled) !important;
}
</style>
